<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' ,fullScreenBackdrop:true}"></ngx-loading>
<main class="main-site-wrap wrapper">
    <!-- <app-header></app-header> -->
    <div class="site-content-wrap position-relative">
        <!--  Start Sign Up Final Steup Verification Screen -->

        <section class="section-wrap py-5 position-relative">
            <div class="container">
                <div class="row align-items-center justify-content-center">
                    <div class="col-12">
                        <div class="staticpage-content-box dark-bg p-4 border-radius10">
                            <h4 class="title pb-3"> {{staticData.title}} </h4>
                            <div class="staticpage-content" [innerHtml]="staticData.description"> </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
    <!-- <app-footer></app-footer> -->
</main>